import { SCENARIOS } from "./data";

/**
 * گزینه‌های اتاقِ مافیا روی وب: سناریو و اندازه‌ی میز. در همین مرورگر به یاد می‌مانند (bazivan.mafia.room).
 * سرور همان را می‌سنجد (match.ValidRules → mafia.FromRoom): سناریو در کلیدِ "scenario" و اندازه با
 * CreateRoom.seats؛ جای خالی ربات است. سفارشی فقط در اپ (چیدنِ نقش‌ها) — این‌جا ۱ تا ۹ و ۱۱ (زودیاک).
 */
export type MafiaRoom = { scenario: number; seats: number };

const KEY = "bazivan.mafia.room";
/** ترتیبِ نمایش (همان MafiaScenarios.All ِ اپ، بی سفارشی). */
export const WEB_SCENARIOS = [1, 2, 3, 11, 4, 5, 6, 7, 8, 9];

/** اندازه به بازه‌ی سناریو. */
export function clampSeats(r: MafiaRoom): MafiaRoom {
  const s = SCENARIOS[r.scenario] ?? SCENARIOS[1]!;
  const scenario = WEB_SCENARIOS.includes(r.scenario) ? r.scenario : 1;
  return { scenario, seats: Math.min(s.max, Math.max(s.min, Math.round(r.seats) || 8)) };
}

export function loadMafiaRoom(): MafiaRoom {
  try {
    const raw = localStorage.getItem(KEY);
    if (raw) {
      const v = JSON.parse(raw) as Partial<MafiaRoom>;
      return clampSeats({ scenario: Number(v.scenario) || 1, seats: Number(v.seats) || 8 });
    }
  } catch { /* حافظه‌ی مرورگر بسته است: پیش‌فرض */ }
  return { scenario: 1, seats: 8 };
}

export function saveMafiaRoom(r: MafiaRoom): void {
  try { localStorage.setItem(KEY, JSON.stringify(clampSeats(r))); } catch { /* بی‌اهمیت */ }
}

/** قانون‌های CreateRoom برای سرور. */
export const mafiaRoomRules = (r: MafiaRoom): Record<string, number> => ({ scenario: clampSeats(r).scenario });
